<div id="add-notification-container">
  <div class="item-container" *ngIf="this.value.notificationId === 13">
    <p class="subheading-01-semi-bold titles">
      Enviar un email con todas las propiedades a vencer en los próximos:
    </p>
    <div id="input-properties" *ngIf="this.value.type === 2">
      <qr-input
        id="input-normal"
        [config]="inputNumber"
        (valueChange)="changeNumber($event)"
        [value]="(this.value.quantity.quantity0 | number : '1.0-0') || 0"
      ></qr-input>
      <p class="hint caption-02-regular">Días</p>
      <div
        class="error-container"
        [ngClass]="{ 'error-height': this.errors['days'] }"
      >
        <qr-icon name="error" color="error-700"></qr-icon>
        <p class="red paragraph-02-regular nomargin">
          Ingrese un número mayor a 7 días
        </p>
      </div>
    </div>
    <p *ngIf="this.value.type === 3" class="data subheading-01-black">
      {{
        this.value.quantity.quantity0 ||
          "El tipo de notificación no tiene valor asignado todavía"
      }}
    </p>
  </div>

  <ng-container *ngIf="this.value.notificationId === 8">
    <p class="paragraph-01-bold grey-600">
      Premios de facturación <span *ngIf="this.NODE === NODE_AR">RA</span>
    </p>
    <ng-container *ngFor="let item of filteredQuantityArray">
      <div
        class="item-container"
        *ngIf="!(this.NODE === this.NODE_EC && item.key === 'quantity0')"
      >
        <p class="subheading-01-semi-bold titles-rewards">
          {{ this.dataArray[item.key] }}
        </p>
        <div id="input-properties" *ngIf="this.value.type === 2">
          <qr-input
            id="input-normal"
            [config]="inputNumber"
            (valueChange)="changeRewards($event, item.key)"
            [value]="(item.value | number : '1.0-0') || 0"
          ></qr-input>
          <p class="hint caption-02-regular">U$S</p>
          <div
            class="error-container"
            [ngClass]="{ 'error-height': this.errors[item.key] }"
          >
            <qr-icon name="error" color="error-700"></qr-icon>
            <p class="red paragraph-02-regular nomargin">
              Ingrese un número válido
            </p>
          </div>
        </div>
        <p *ngIf="this.value.type === 3" class="data subheading-01-black">
          {{ (item.value | number : "1.0-0") || 0 }}
        </p>
      </div></ng-container
    ></ng-container
  >

  <ng-container
    *ngIf="
      this.value.notificationId === 7 ||
      this.value.notificationId === 6 ||
      this.value.notificationId === 5
    "
  >
    <p class="subheading-01-semi-bold titles" id="p-title">
      Podés agregar hasta cinco valores distintos
    </p>
    <ng-container *ngFor="let item of this.quantity | keyvalue; let i = index">
      <div class="item-container" *ngIf="i < 5">
        <p class="subheading-01-semi-bold titles-rewards">Al alcanzar</p>
        <div id="input-properties" *ngIf="this.value.type === 2">
          <qr-input
            id="input-normal"
            [config]="inputNumber"
            (valueChange)="changeRewards($event, item.key)"
            [value]="(item.value | number : '1.0-0') || 0"
          ></qr-input>
          <div
            class="error-container"
            [ngClass]="{ 'error-height': this.errors[item.key] }"
          >
            <qr-icon name="error" color="error-700"></qr-icon>
            <p class="red paragraph-02-regular nomargin">
              Ingrese un número válido
            </p>
          </div>
        </div>
        <p *ngIf="this.value.type === 3" class="data subheading-01-black">
          {{ (item.value | number : "1.0-0") || 0 }}
        </p>
      </div></ng-container
    ></ng-container
  >
</div>
